import { render, staticRenderFns } from "./CourseSupport.vue?vue&type=template&id=3224b4e2&scoped=true"
import script from "./CourseSupport.vue?vue&type=script&lang=js"
export * from "./CourseSupport.vue?vue&type=script&lang=js"
import style0 from "./CourseSupport.vue?vue&type=style&index=0&id=3224b4e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3224b4e2",
  null
  
)

export default component.exports